import { Box, Button, Card, CardContent, FormControl, FormGroup, Input, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from '@material-ui/core';
import { ANAO, ASIM, ATIPO_VENDEDOR_EXTERNO, ATIPO_VENDEDOR_INTERNO } from 'consts';
import React, { Component, useRef } from 'react';
import { Link } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import api from '../../../services/api';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ComboPadraoMultiple from 'views/Components/ComboPadraoMultiple';
import { getConfigField } from 'lib/configUtils';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import DeleteConfirmationModal from 'components/DeleteConfirmationModal/DeleteConfirmationModal';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import {
    buildListParams,
    getListData,
    getTotalRecords,
    handleListDeleteIconMouseEnter,
    handleListIconMouseEnter,
    handleListIconMouseLeave,
    listStyles,
    loadStoredJson,
    removeStoredKeys,
    saveStoredValue
} from 'lib/listUtils';
import {
    BackspaceOutlined,
    DeleteForeverOutlined,
    EditTwoTone,
    VisibilityOutlined
} from '@material-ui/icons';

import { Tooltip } from '@material-ui/core';

class VendedorList extends Component {
    state = {
        vendedores: [],

        searchFilter: loadStoredJson('vendedorSearchFilter', {
            nomeVendedor: '',
            tipo: 'T',
            situacaoInativoFilter: ANAO,
            codCliente: 0,
            empresas: []
        }),

        page: Number(sessionStorage.getItem('vendedorPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('vendedorRowsPerPage')) || 50,
        totalItems: 0,

        listaClientes: [],
        clienteSelecionado: null,
        textoPesquisaCliente: '',
        clientesPage: 1,
        clientesTotal: 0,
        clientesLoading: false,
        listaEmpresas: [],

        excluindo: false
    };

    handleIconMouseEnter = handleListIconMouseEnter;
    handleIconMouseLeave = handleListIconMouseLeave;
    handleDeleteIconMouseEnter = handleListDeleteIconMouseEnter;

    estilo = listStyles;

    constructor(props) {
        super(props);
    }

    /* carregamento inicial */
    async componentDidMount() {
        this.carregarClientes('', 1, false);

        const empresasResponse = await api.get('/empresa');

        const listaEmpresas = empresasResponse.data.map(empresa => ({
            id: empresa.codigo,
            item: empresa.fantasia
        }));

        const codEmpresa = sessionStorage.getItem('codEmpresa');

        this.setState(prevState => ({
            listaEmpresas,
            searchFilter: {
                ...prevState.searchFilter,
                empresas: listaEmpresas.filter(
                    empresa => empresa.id == codEmpresa
                )
            }
        }), () => {
            this.loadVendedores();
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.searchFilter !== this.state.searchFilter) {
            saveStoredValue('vendedorSearchFilter', this.state.searchFilter);
        }

        if (prevState.page !== this.state.page) {
            saveStoredValue('vendedorPage', this.state.page);
        }

        if (prevState.rowsPerPage !== this.state.rowsPerPage) {
            saveStoredValue('vendedorRowsPerPage', this.state.rowsPerPage);
        }
    }

    componentWillUnmount() {
        removeStoredKeys([
            'vendedorSearchFilter',
            'vendedorPage',
            'vendedorRowsPerPage'
        ]);
    }

    /* Carrega vendedores */
    loadVendedores = async () => {
        const { searchFilter, page, rowsPerPage, listaEmpresas } = this.state;

        const filters = [];

        // Consulta pelo nome do vendedor
        if (searchFilter.nomeVendedor !== '') {
            filters.push({
                field: 'nomevendedor',
                value: searchFilter.nomeVendedor,
                operator: '_like_'
            });
        }

        // Filtra tipo de vendedor
        switch (searchFilter.tipo) {
            case 'E':
                filters.push({
                    field: 'tipo',
                    value: ATIPO_VENDEDOR_EXTERNO
                });
                break;

            case 'I':
                filters.push({
                    field: 'tipo',
                    value: ATIPO_VENDEDOR_INTERNO
                });
                break;

            default:
                break;
        }

        // Filtra situação do vendedor
        if (
            searchFilter.situacaoInativoFilter === ASIM ||
            searchFilter.situacaoInativoFilter === ANAO
        ) {
            filters.push({
                field: 'inativo',
                value: searchFilter.situacaoInativoFilter
            });
        }

        // Filtra pelo cliente vinculado
        if (searchFilter.codCliente && searchFilter.codCliente !== 0) {
            filters.push({
                field: 'codcliente',
                value: searchFilter.codCliente
            });
        }

        // Filtra pelas empresas selecionadas
        if (listaEmpresas.length > 1) {
            const empresas = (searchFilter.empresas || [])
                .map(empresa => empresa.id);

            if (empresas.length > 0) {
                filters.push({
                    field: 'empresas',
                    value: empresas.join(',')
                });
            }
        }

        const params = buildListParams({
            page,
            rowsPerPage,
            filters
        });

        try {
            const response = await api.get(
                `/vendedor${params}&sort=nomevendedor`
            );

            this.setState({
                vendedores: getListData(response),
                totalItems: getTotalRecords(response)
            });
        } catch (error) {
            console.error('Erro ao carregar vendedores:', error);

            this.setState({
                vendedores: [],
                totalItems: 0
            });
        }
    };

    /* Escolha de uma conta para exclusão */
    handleSelectItem = (id, nome) => {
        this.setState({
            selectedId: id,
            selectedNome: nome
        });
    };

    /* deleta vendedor */
    handleDelete = async (id) => {
        if (this.state.excluindo) return;

        this.setState({ excluindo: true });

        try {
            const response = await api.delete(`/vendedor/${id}`);

            if (response.status === 200) {
                this.handleClose();

                await this.loadVendedores();
            }
        } catch (error) {
            this.handleClose();

            this.handleOpenAlert(
                error.response?.data?.error ||
                'Não foi possível excluir o vendedor!'
            );

            console.error('Erro ao excluir vendedor:', error);
        } finally {
            this.setState({ excluindo: false });
        }
    };

    /* abre janela confirmação para exclusão */
    handleOpen = (codvendedor, nomevendedor) => {
        this.setState({ open: true });
        this.handleSelectItem(codvendedor, nomevendedor);
    };

    /* abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* fecha janela de confirmação exclusão */
    handleClose = () => {
        this.setState({ open: false });
    };

    /* fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    }

    /* Pesquisar filtros na tela */
    OnChangeSearch = (event) => {
        const { name } = event.target;
        let { value } = event.target;

        if (name !== 'codCliente') {
            value = value.toUpperCase();
        }

        this.setState(prevState => ({
            searchFilter: {
                ...prevState.searchFilter,
                [name]: value
            },
            page: 0
        }), () => {
            if (name === 'situacaoInativoFilter') {
                this.loadVendedores();
            }
        });
    };

    /* Limpa Filtros na tela */
    LimpaFiltros = () => {
        const codEmpresa = sessionStorage.getItem('codEmpresa');
        const { listaEmpresas } = this.state;

        this.setState(prevState => ({
            searchFilter: {
                ...prevState.searchFilter,
                nomeVendedor: '',
                tipo: 'T',
                situacaoInativoFilter: ANAO,
                codCliente: 0,
                empresas: listaEmpresas.filter(
                    empresa => empresa.id == codEmpresa
                )
            },
            clienteSelecionado: null,
            textoPesquisaCliente: '',
            page: 0
        }), () => {
            this.loadVendedores();
        });
    };

    handleSearch = () => {
        let errors = this.validationRequiredFields();

        if (!(errors === '')) {
            this.handleOpenAlert(errors);
        } else {
            this.loadVendedores();
        }
    };

    validationRequiredFields = () => {
        const { searchFilter } = this.state;
        let errors = '';

        return errors;
    };

    /* Mudança de página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => {
            this.loadVendedores();
        });
    };

    /* Mudança na quantidade de linhas por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 }, () => {
            this.loadVendedores();
        });
    };

    carregarClientes = async (search = '', page = 1, append = false) => {
        if (this.state.clientesLoading) return;

        this.setState({ clientesLoading: true });

        try {
            const params = buildListParams({
                page: page - 1,
                rowsPerPage: 20,
                filters: [
                    {
                        field: 'FANTASIA',
                        value: search,
                        operator: '_like_'
                    }
                ]
            });

            const response = await api.get(
                `/cliente/active/true${params}&sort=FANTASIA`
            );

            const clientesRecebidos = response.data.data || [];
            const info = response.data.info || {};

            this.setState(prevState => ({
                listaClientes: append
                    ? [
                        ...prevState.listaClientes,
                        ...clientesRecebidos.filter(
                            novo => !prevState.listaClientes.some(
                                existente =>
                                    existente.codcliente === novo.codcliente
                            )
                        )
                    ]
                    : clientesRecebidos,

                clientesPage: page,
                clientesTotal: Number(info.totalrecords || 0),
                clientesLoading: false
            }));
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            this.setState({ clientesLoading: false });
        }
    };

    pesquisarClientes = (texto) => {
        clearTimeout(this.timerPesquisaClientes);

        this.setState({
            textoPesquisaCliente: texto
        });

        this.timerPesquisaClientes = setTimeout(() => {
            this.carregarClientes(texto, 1, false);
        }, 350);
    };

    handleScrollClientes = (event) => {
        const lista = event.target;

        const chegouAoFinal =
            lista.scrollTop + lista.clientHeight >= lista.scrollHeight - 20;

        const {
            clientesLoading,
            clientesPage,
            clientesTotal,
            listaClientes,
            textoPesquisaCliente
        } = this.state;

        if (
            chegouAoFinal &&
            !clientesLoading &&
            listaClientes.length < clientesTotal
        ) {
            this.carregarClientes(
                textoPesquisaCliente,
                clientesPage + 1,
                true
            );
        }
    };

    handleChangeCliente = (event, cliente) => {
        this.setState(prevState => ({
            clienteSelecionado: cliente,
            searchFilter: {
                ...prevState.searchFilter,
                codCliente: cliente ? cliente.codcliente : 0
            }
        }), () => {
            this.loadVendedores();
        });
    };

    OnChangeEmpresas = (empresas) => {
        this.setState(prevState => ({
            searchFilter: {
                ...prevState.searchFilter,
                empresas
            }
        }), () => {
            this.loadVendedores();
        });
    };

    render() {
        const {
            vendedores,
            searchFilter,
            page,
            rowsPerPage,
            totalItems,
            listaClientes,
            listaEmpresas,
            clienteSelecionado,
            clientesLoading,
            isView,
            open,
            selectedId,
            selectedNome,
            openAlert,
            messageAlert,
            excluindo
        } = this.state;

        const {
            actionIcon,
            addButton,
            filterPaper,
            iconGroup,
            redText
        } = this.estilo;

        // campos configurações
        const possibvincvendedorcliente = (getConfigField('possibvincvendedorcliente') == ASIM);

        return (
            <div style={this.estilo}>
                <Paper
                    style={{
                        ...filterPaper,
                        width: '100%',
                        display: 'flex',
                        alignItems: 'flex-end',
                    }}
                >
                    <Input
                        autoFocus
                        id="nomeVendedor"
                        name="nomeVendedor"
                        onChange={this.OnChangeSearch}
                        placeholder="Nome vendedor a pesquisar"
                        style={{
                            width: 300,
                            margin: '0 10px'
                        }}
                        value={searchFilter.nomeVendedor}
                    />

                    <FormControl
                        style={{
                            flex: '0 1 140px',
                            minWidth: 140,
                            marginBottom: 0
                        }}
                    >
                        <InputLabel id="input-label">Tipo</InputLabel>
                        <Select
                            id="tipo"
                            name="tipo"
                            value={searchFilter.tipo || ''}
                            onChange={this.OnChangeSearch}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null
                            }}
                        >
                            <MenuItem value="T">Todos</MenuItem>
                            <MenuItem value="I">Interno</MenuItem>
                            <MenuItem value="E">Externo</MenuItem>
                        </Select>
                    </FormControl>

                    <Select
                        id="situacaoInativoFilter"
                        name="situacaoInativoFilter"
                        value={searchFilter.situacaoInativoFilter || ''}
                        onChange={this.OnChangeSearch}
                        style={{
                            flex: '0 1 100px',
                            minWidth: 100,
                            textAlign: 'center'
                        }}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left'
                            },
                            getContentAnchorEl: null
                        }}
                    >
                        <MenuItem value={ANAO} style={{ justifyContent: 'center' }}>
                            Ativos
                        </MenuItem>

                        <MenuItem value={ASIM} style={{ justifyContent: 'center' }}>
                            Inativos
                        </MenuItem>

                        <MenuItem value="T" style={{ justifyContent: 'center' }}>
                            Todos
                        </MenuItem>
                    </Select>

                    <span style={iconGroup}>
                        <Tooltip title="Procurar">
                            <SearchIcon
                                onClick={this.handleSearch}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>

                        <Tooltip title="Limpar">
                            <BackspaceOutlined
                                onClick={this.LimpaFiltros}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to="/front/vendedores/novo"
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                {(possibvincvendedorcliente || listaEmpresas.length > 1) && (<Paper
                    style={{
                        ...filterPaper,
                        width: '100%'
                    }}
                >
                    <Box
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'flex-end',
                            gap: 20,
                            paddingTop: 5
                        }}
                    >
                        {possibvincvendedorcliente && (<Box style={{ marginLeft: 10, width: 300 }}>
                            <Autocomplete
                                options={listaClientes}
                                value={searchFilter.codCliente
                                    ? (
                                        listaClientes.find(
                                            cliente =>
                                                cliente.codcliente ===
                                                searchFilter.codCliente
                                        ) || clienteSelecionado
                                    )
                                    : null
                                }
                                getOptionLabel={option =>
                                    option.fantasia || option.cliente || ''
                                }
                                getOptionSelected={(option, value) =>
                                    option.codcliente === value.codcliente
                                }
                                loading={clientesLoading}
                                onChange={this.handleChangeCliente}
                                onInputChange={(event, value, reason) => {
                                    if (reason === 'input' || reason === 'clear') {
                                        this.pesquisarClientes(
                                            reason === 'input' ? value.toUpperCase() : value
                                        );
                                    }
                                }}
                                ListboxProps={{
                                    onScroll: this.handleScrollClientes
                                }}
                                noOptionsText="Nenhum cliente encontrado"
                                loadingText="Carregando clientes..."
                                clearText="Limpar"
                                openText="Abrir"
                                closeText="Fechar"
                                disabled={isView}
                                style={{ width: 300 }}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        label="Cliente"
                                        variant="standard"
                                        placeholder="Digite para pesquisar"
                                    />
                                )}
                                renderOption={(option) => (
                                    <span style={{ whiteSpace: 'pre-wrap' }}>
                                        {option.fantasia || option.cliente || ''}
                                    </span>
                                )}
                                filterOptions={(options) => options}
                            />
                        </Box>)}

                        {listaEmpresas.length > 1 && (
                            <Box style={{ marginLeft: 10, width: 300 }}>
                                <ComboPadraoMultiple
                                    options={searchFilter.empresas}
                                    label="Empresas"
                                    itens={listaEmpresas}
                                    onSelectionChange={this.OnChangeEmpresas}
                                />
                            </Box>
                        )}
                    </Box>
                </Paper>)}

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div >
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Código</TableCell>
                                            <TableCell align="center">Nome</TableCell>
                                            <TableCell align="center">Tipo</TableCell>
                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {vendedores.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={4} align="center">
                                                    Nenhum vendedor encontrado.
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            vendedores.slice(0, 1000).map(vendedor => (
                                                <TableRow
                                                    hover
                                                    key={vendedor.codvendedor}
                                                >
                                                    <TableCell align="center" style={(vendedor.inativo === ASIM) ? redText : {}}>{vendedor.codvendedor}</TableCell>

                                                    <TableCell align="center" style={(vendedor.inativo === ASIM) ? redText : {}} >{vendedor.nomevendedor}</TableCell>

                                                    <TableCell align="center" style={(vendedor.inativo === ASIM) ? redText : {}} >
                                                        {((vendedor.vendedorexterno == ASIM) ? 'Externo' : 'Interno')}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        <span style={iconGroup}>
                                                            <Tooltip title="Editar">
                                                                <Link to={`/front/vendedores/${vendedor.codvendedor}`}>
                                                                    <EditTwoTone
                                                                        onMouseEnter={this.handleIconMouseEnter}
                                                                        onMouseLeave={this.handleIconMouseLeave}
                                                                        style={actionIcon}
                                                                    />
                                                                </Link>
                                                            </Tooltip>

                                                            <Tooltip title="Visualizar">
                                                                <Link to={`/front/vendedores/${vendedor.codvendedor}/view`}>
                                                                    <VisibilityOutlined
                                                                        onMouseEnter={this.handleIconMouseEnter}
                                                                        onMouseLeave={this.handleIconMouseLeave}
                                                                        style={actionIcon}
                                                                    />
                                                                </Link>
                                                            </Tooltip>

                                                            <Tooltip title="Excluir">
                                                                <DeleteForeverOutlined
                                                                    onClick={() => this.handleOpen(vendedor.codvendedor, vendedor.nomevendedor)}
                                                                    onMouseEnter={this.handleDeleteIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Tooltip>
                                                        </span>
                                                    </TableCell>

                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>
                    </CardContent>
                </Card>

                <TablePagination
                    component="div"
                    labelRowsPerPage={'Registros por página'}
                    rowsPerPageOptions={[50, 100, 150]}
                    count={totalItems}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                    labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
                    }
                />

                <DeleteConfirmationModal
                    open={open}
                    handleClose={() => this.handleClose()}
                    itemId={selectedId}
                    message={'Confirma exclusão do vendedor ' + selectedNome + '?'}
                    handleDelete={() => this.handleDelete(selectedId)}
                    loading={excluindo}
                />

                <AlertInformation
                    open={openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={messageAlert}
                />
            </div>
        );
    }
}

export default VendedorList;